import React from "react"
import { Row, Col } from "react-bootstrap"
import TestCardProps from "./TestCardProps"
import CardRow from "./CardRow"
import AccordionCard from "./AccordionCard"

export default function TestScreeningCard(props: TestCardProps) {
  const { data } = props
  const title = <Row>
    <Col xs={6}>TESTING SCREENING: <span className="status-text">{data.ScreenResultDescription}</span></Col>
    <Col xs={6}>TESTING CONFIRMATION: <span className="status-text">{data.ConfirmResultDescription}</span></Col>
  </Row>
  return (
    <AccordionCard eventKey="testScreening" title={title}>
      <Row>
        <Col xs={6}>
          <CardRow title="SAMPLE TYPE" value={data.ScreenSampleTypeDescription}/>
          <CardRow title="DEVICE" value={data.ScreenDeviceCode}/>
          <CardRow title="DEVICE #" value={data.ScreenDeviceSerialNumber}/>
          <CardRow title="DEVICE EXPIRATION DATE" value={data.ScreenDeviceExpirationDate} date/>
          <CardRow title="TEST NUMBER" value={data.ScreenSequence}/>
          <CardRow title="LEVEL" value={data.ScreenLevel}/>
        </Col>
        <Col xs={6}>
          <CardRow title="SAMPLE TYPE" value={data.ConfirmSampleTypeDescription}/>
          <CardRow title="DEVICE" value={data.ConfirmDeviceCode}/>
          <CardRow title="DEVICE #" value={data.ConfirmDeviceSerialNumber}/>
          <CardRow title="DEVICE EXPIRATION DATE" value={data.ConfirmDeviceExpirationDate} date/>
          <CardRow title="TEST NUMBER" value={data.ConfirmSequence}/>
          <CardRow title="LEVEL" value={data.ConfirmLevel}/>
        </Col>
      </Row>
    </AccordionCard>
  )
}
